import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SearchServiceModel } from './model';

export const adapter: EntityAdapter<SearchServiceModel> = createEntityAdapter<SearchServiceModel>({
  selectId: model => model.id,
});

export interface SearchServiceState extends EntityState<SearchServiceModel> {
  selected: SearchServiceModel;
  isLoading?: boolean;
  error?: any;
}

export const initialState: SearchServiceState = adapter.getInitialState({
  selected: null,
  isLoading: false,
  error: null,
});
